import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Heart, Storefront } from "@phosphor-icons/react";
import { api } from "@/api";
import { ProductCard } from "@/components/ProductCard";
import { Button } from "@/components/ui/button";
import { toast } from "@/components/ui/sonner";

export default function FavoritesPage({ user, authLoading, onAddToCart }) {
  const navigate = useNavigate();
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = useCallback(() => {
    api.get("/favorites").then(({ data }) => setFavorites(data)).catch(() => toast.error("Could not load favorites")).finally(() => setLoading(false));
  }, []);
  useEffect(() => {
    if (authLoading) return;
    if (!user) { navigate("/auth"); return; }
    load();
  }, [authLoading, user, navigate, load]);
  const removeFavorite = async (listing) => {
    await api.delete(`/favorites/${listing.id}`);
    setFavorites((current) => current.filter((item) => item.id !== listing.id));
    toast.success("Favorite removed");
  };

  if (authLoading) return <main data-testid="favorites-auth-loading" className="p-10 text-[#F7F2EA]">Checking your account...</main>;
  return (
    <main data-testid="favorites-page" className="min-h-[calc(100vh-74px)] px-4 py-12 md:px-8">
      <section className="mx-auto max-w-7xl">
        <div className="mb-8 flex flex-col justify-between gap-5 md:flex-row md:items-end"><div><p data-testid="favorites-kicker" className="text-xs uppercase tracking-[0.22em] text-[#D86F55]">Saved market</p><h1 data-testid="favorites-heading" className="text-5xl font-light text-[#F7F2EA] md:text-6xl">Favorites</h1></div><Button data-testid="favorites-market-link" asChild variant="outline" className="rounded-none border-[#D86F55]/60 bg-transparent text-[#F7F2EA]"><Link to="/"><Storefront size={18} /> Browse market</Link></Button></div>
        {loading ? <p data-testid="favorites-loading" className="text-[#F7F2EA]">Loading favorites...</p> : favorites.length === 0 ? <div data-testid="favorites-empty" className="border border-[#8E3F31] bg-[#1F2E25] p-10 text-[#F7F2EA]"><Heart size={30} /><p className="mt-3">No favorites saved yet.</p></div> : <div data-testid="favorites-grid" className="grid gap-7 sm:grid-cols-2 xl:grid-cols-3">{favorites.map((listing) => <ProductCard key={listing.id} listing={listing} onAdd={onAddToCart} favoriteSaved onToggleFavorite={removeFavorite} />)}</div>}
      </section>
    </main>
  );
}